import { useState } from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { Tooltip } from 'src/components/atoms';
import { useTheme } from 'styled-components';

interface Props {
  text: string;
}

export const InfoIconPopup = ({ text }: Props) => {
  const theme = useTheme();
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [root, setRoot] = useState<HTMLElement | null>(null);
  return (
    <div>
      <StyledIcon
        className={'uil uil-info-circle'}
        onMouseOver={() => setTooltipVisible(true)}
        onMouseOut={() => setTooltipVisible(false)}
        ref={setRoot}
        color={
          tooltipVisible
            ? theme.atlas.semantic.color.action.primary.default
            : theme.atlas.semantic.color.type.default
        }
        size="20px"
        data-testid="hero-metric-information"
      />
      {tooltipVisible && root && (
        <Tooltip
          text={text}
          variant="down"
          root={root}
          data-testid="hero-metric-tooltip"
        />
      )}
    </div>
  );
};
